import { END_POINT } from "constants/apiConstant";
import { apiGet, apiPost } from "../utils/apiUtils";

export const getAllCompanyUsersApi = async () => {
  const response = await apiGet(END_POINT.GET_ALL_COMPANY_USERS_API);
  return response;
};

export const updateCompanyUserApi = async ({ id, payload }) => {
  const response = await apiPost(END_POINT.UPDATE_COMPANY_USER_API + id, payload);
  return response;
};
